import React, { useState } from 'react'
import { Dropdown, Menu } from 'antd'
import Select from 'react-select'

import { AiOutlineDown } from 'react-icons/ai'

import EditInputForm from '../../../components/drawers/editInputForm'
import NewInputForm from '../../../components/drawers/newInputForm'
import Receive from '../../../components/reusable/receive'

import { stringifyDate, useListData, usePet, useToggle } from '../../../modules'

const InputForms = () => {
    const [selected, setSelected] = useState()
    const [category, setCategory] = useState()
    const [string, setString] = useState('')

    const [newInputForm, toggleNewInputForm] = useToggle()
    const [editInputForm, toggleEditInputForm] = useToggle()
    // const [inputForm, toggleInputForm] = useToggle()

    const select = form => {
        setSelected(form)
        toggleEditInputForm()
    }
    
    const [
        { loading, error, fetch }, 
        { list: forms }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('inputForms', { string, category: category?.value }, { notify: true, manual: false }, 'forms')

    const [{ data: categories }, getCategories] = usePet('inputFormCategories', {}, { notify: true })

    const refresh = () => {
        navigate(1)
        fetch()
        getCategories()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const changeCategory = dept => {
        setCategory(dept)
        refresh()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto">
            {
                newInputForm &&
                <NewInputForm
                    onPerform={ refresh }
                    visible={ newInputForm }
                    categories={ categories }
                    toggle={ toggleNewInputForm } />
            }            
            {
                editInputForm &&
                <EditInputForm
                    form={ selected }
                    onPerform={ refresh }
                    visible={ editInputForm } 
                    categories={ categories }
                    toggle={ toggleEditInputForm } />
            }
            {/* {
                inputForm &&
                <InputForm
                    onPerform={ refresh }
                    visible={ inputForm }
                    categories={ categories }
                    toggle={ toggleInputForm } />
            } */}
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Search by Name" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={ toggleNewInputForm } className="btn hisani-btn-green-light text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">New Input Form</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 flex justify-between items-center border-b border-gray-100">
                    <h2 className="font-semibold text-gray-800">Input Forms</h2>
                    <Select
                        isClearable
                        value={ category }
                        onChange={ changeCategory }
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={ categories?.map(cat => ({ label: cat, value: cat }))}
                        placeholder="Select Category" />
                </header>
                <div className="p-3 overflow-x-auto">
                    <Receive
                        error={error}
                        loading={loading}
                        progress>
                        {
                            forms.length > 0 ?
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm text-left">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Name</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Category</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Created By</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold">Date</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold"></div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {/* Table body */}
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {/* Row */}
                                        {
                                            forms.map((form, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div>{((page - 1) * limit) + key + 1}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="">{ form.name }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div>{ form?.category }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div>{ form?.createdBy?.name }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <div>{ stringifyDate(form.createdOn) }</div>
                                                    </td>
                                                    <td className="p-2">
                                                        <Dropdown
                                                            overlay={
                                                                <Menu>
                                                                    <Menu.Item onClick={ () => select(form) }>View</Menu.Item>
                                                                </Menu>
                                                            }>
                                                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                        </Dropdown>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">Please click above to add a new form</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
        </div>
    )
}

export default InputForms